import React,{useState} from 'react';
import { ButtonToolbar, Button, ModalFooter } from 'react-bootstrap';
import './styles/App.css';

import MiddleContent from './MiddleContent';  
import MidContent from './MidContent'; 
import MiddleSection_ab from './MiddleSection_ab';
import LastSection_ab from './LastSection_ab';
import MainSlide from './MainSlide';


function Content({history}){

    const [isShown, setIsShown] = useState(false);
    const [isShown2, setIsShown2] = useState(false);
    const [isShown3, setIsShown3] = useState(false);
    const [isShown4, setIsShown4] = useState(false);
    const [isShown5, setIsShown5] = useState(false);
    const [isShown6, setIsShown6] = useState(false);
    const [isShown7, setIsShown7] = useState(false);

    const cursorPointer = {
        cursor:"pointer"
    }
    
    return(
    
        
            <>
            {/* <MainSlide /> */}

            <div>

            </div>
            {/* <MidContent  history={history} /> */}
            {/* <MiddleContent history={history}/> */}
            {/* <MiddleSection_ab /> */}
            <div style={{backgroundColor:'#EFEFEF',wordBreak:'keep-all'}}>
                <div className="container py-5">
                    <p className="font-weight-bold" style={{color:'#00479D',fontSize:'20px'}}>ABYS의 주요 서비스</p>
                    <div className="row p-0">
                        <div className="col-6 mb-5" style={{paddingLeft:'8px'}}>
                            <span style={{marginLeft:'-9px',fontSize:'16px'}}>- ABYS 토탈멀티서비스는 자동차와 건물의 크리닝과 윈도우필름을 통한 에너지 세이빙, 외관의 유지관리를 컨설팅 및 서비스 진행, 사후관리를 진행하는 토탈 관리 서비스입니다.</span>
                        </div>
                        <div className="col-6 mb-5">
                            <span style={{marginLeft:'-9px',fontSize:'16px'}}>- ABYS 서비스는 <b>ICT (Information & Communication Technology)</b> 기술을 도입한 서비스 관리 프로그램 입니다.</span>
                        </div>
                        <div className="col-6" style={{paddingLeft:'8px'}}>
                            <span style={{marginLeft:'-11px',fontSize:'16px'}}>- 우리나라 환경에 맞춘 서비스 SOP(Standard Operation Precedure - 표준작업절차)를 개발하여 전국 동일 서비스품질을 공급합니다.</span>
                        </div>
                        <div className="col-6">
                            <span style={{marginLeft:'-9px',fontSize:'16px'}}> - ABYS 서비스는 서비스에 사용되는 재료의 브랜드가 상이하므로 A/S가 발생 시 시공하신 대리점에서만 서비스가 가능합니다.</span>
                        </div>
                    </div>
                </div>
            </div>
            <LastSection_ab history={history}/>
            </>
            
    )

}


export default Content;